import React from 'react';
import { MyVideosTeaserContent } from './MyVideosTeaserContent';
import { useShowState, useTopicState, useWatchLaterState } from '../../../providers/DataProvider/DataContext';
import { useVideoHistory } from '../../../providers/VideoHistoryProvider/VideoHistoryContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyVideosTeaser = () => {
  const {
    continueWatchingIds
  } = useVideoHistory();
  const {
    videoUrns: watchLaterUrns
  } = useWatchLaterState();
  const {
    favoriteShowIds
  } = useShowState();
  const {
    topicFavorites
  } = useTopicState();
  const labels = [{
    count: continueWatchingIds.length,
    translationKey: 'global.continueWatchingCount'
  }, {
    count: watchLaterUrns.length,
    translationKey: 'global.watchLaterCount'
  }, {
    count: favoriteShowIds.length,
    translationKey: 'global.favoriteShowsCount'
  }, {
    count: topicFavorites.length,
    translationKey: 'global.favoriteTopicsCount'
  }];
  return /*#__PURE__*/_jsx(MyVideosTeaserContent, {
    labels: labels
  });
};